import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

// config.json publico so carrega o apiBaseUrl (ex.: "/rest", mesma origem ->
// nginx -> BFF). A credencial de integracao NAO fica mais aqui (era servida
// como asset estatico e vazava) - ela vive no /etc/gnf-bff.env server-side.
interface AppConfig {
  apiBaseUrl: string;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private apiBaseUrl: string = '';
  private http: HttpClient;

  constructor(handler: HttpBackend) {
    // HttpBackend bypassa os interceptors — evita dependencia circular
    this.http = new HttpClient(handler);
  }

  loadConfig(): Promise<void> {
    return firstValueFrom(this.http.get<AppConfig>('assets/config.json')).then(config => {
      this.apiBaseUrl = config.apiBaseUrl;
    });
  }

  getHostRest(): string {
    return this.apiBaseUrl;
  }
}
